<!--  -->
<template>
  <div class="c_homeNotice">
    <h2 class="c_Title">{{currentContent.title}}</h2>
    <div class="c_Content" v-html="currentContent.desc"></div>
  </div>
</template>
<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        contents: [
          {
            path: 'notice1',
            title: '智慧供应链库存产品诸葛.智享全面升级袭来！',
            desc: `
              <p>尊敬的诸葛.智享用户：</p>
              <p>您好！</p>
              <p>
              为进一步提升用户体验，提供更好的服务品质，诸葛.智享将于即日起上线新版库存管理产品。此版本共包含：存货布局、库存健康、 销量计划、智能补货、滞销处理、报表中心六块功能，具体功能介绍：
              </p>
              <p>一、存货布局 存货布局系统通过数据挖掘，分析商家的经营数据，分析商家存货布局的现状，结合大数据预测结果洞悉商家未来的经营趋势，模拟仿 真，在商家期望的时效渗透率及成本约束下，给出极值的分仓建议，提升用户体验。针对畅销爆品，借助后台丰富的算法，实现预测补货， 柔性进行库存部署。产品主要包括：总体分析、分区分析、爆品分析三大块功能。
              </p>
              <p>二、库存健康 集库存监控、库存诊断及优化建议、商品分类处理执行、供应链全链路运营监控于一体，完美地实现了库存管理的闭环模式。通过大 数据分析，指导铺货，优化库存区域布局，提前预防库存分布不均问题，减少风险。帮助库存管理决策，提高效率，降低成本，通过对库 存进行专业诊断进而为商家输出优化建议。产品主要包括：库存看板、库存预警、库存规划设置三大块功能。
              </p>
              <p>三、销量计划 依托京东既有的大数据和人工智能技术，提升消费者与商品的结合效率，优化竞争、销售和利润。电商平台在做销售预测时，需要综 合考虑销量及各种促销、品类趋势预测、外部市场环境、突发事件等各方面因素的影响。产品主要包括：销售总体分析、销量预测分析图、 预测模型设置三大块功能。
              </p>
              <p>四、智能补货 基于京东多年供应链管理经验，依托YAIR（Y AI Platform for Retail）零售行业人工智能平台提供的大数据和算法能力，智能补货产品， 面向京东第三方卖家打造了一个是便捷易用的补货决策工具，一款助力商家运营的补货产品，为商家提供智能化、自动化的补货建议。产品 主要包括：补货看板、补货工作台、补货参数管理三大块模块。
              </p>
              <p>五、滞销处理 为商家节约仓储成本、简化滞销商品退货流程，最优处理模式。锁定滞销处理平台帮助商家轻松找到存放在仓里的“问题商品”，包括高 周转、残品、脏品、临期锁定、过期锁定商品；智能给出处理建议，残品、临期自动退，连续滞销品和重点清理品着重处理；可视化滞销概 况一览，个性化制定滞销方式、滞销级别。产品主要包括：滞销概览、智能退货、滞销参数设置三大块模块。
              </p>
              <p>六、报表中心 方便商家快速查看库存相关所需要的报表，主要包括：库存报表、销售报表、库存销售报表、库存不足报表、滞销明细报表、不动销明细报表。
              </p>
              <p>具体产品细则请见相关产品介绍页面、产品操作手册、新手导航等。或者加入QQ客服群：726336845，由我们客服为您解答。</p>
              <p>感谢您对我们一如既往的支持和鼓励，我们会尽最大的努力给大家带来更好的服务！</p>
              <p>诸葛.智享</p>
              <p>2017年11月16日</p>
            `,
          },
          {
            path: 'notice2',
            title: '参与调研，助力产品解决更多您的诉求 ！',
            desc: `
              <p>尊敬的诸葛.智享用户：</p>
              <p>您好！</p>
              <p>
                为了诸葛.智享产品更好的满足您的需求，我们制作了一份产品使用调研问卷，
                您可以点击以下链接：
                <a href="http://cn.mikecrm.com/pfC1Kn7" target="_blank">http://cn.mikecrm.com/pfC1Kn7</a>，
                将您平时对自己库存管理的方式反馈给我们，
                便于我们更好的设计产品逻辑，更全面满足您的需求！
              </p>
              <p>诸葛.智享</p>
              <p>2017年11月16日</p>
            `,
          },
          {
            path: 'notice3',
            title: '产品使用文档，欢迎下载！',
            desc: `
              <p>尊敬的诸葛.智享用户：</p>
              <p>您好！</p>
              <p>
                如果您对产品的操作上还存在疑问，您可以通过该地址：www.jd.com，查找相关产品使用手册，
                熟悉产品的操作步骤，方便您快速熟悉和使用诸葛.智享库存产品！
              </p>
              <p>诸葛.智享</p>
              <p>2017年11月16日</p>
            `,
          },
          {
            path: 'notice4',
            title: '产品售后服务，问题解答渠道通知！',
            desc: `
              <p>尊敬的诸葛.智享用户：</p>
              <p>您好！</p>
              <p>如果您在使用诸葛.智享产品过程中，出现问题，我们为您提供丰富的问题解答渠道，您可以通过以下渠道解决您的问题：</p>
              <p>
                卖家论坛：
                <a href="http://mjbbs.jd.com/forum-155-1.html" target="_blank">http://mjbbs.jd.com/forum-155-1.html</a>
              </p>
              <p>QQ客服群：726336845</p>
              </p>2017年11月16日</p>
            `,
          },
          {
            path: 'notice5',
            title: '产品常见问题介绍。',
            desc: `
              <p>尊敬的诸葛.智享用户：</p>
              <p>您好！</p>
              <p>
                我们为您提供了每块产品在使用过程中，可能会遇到的一些常见的问题清单，您可以通过首页的常见问题页面查看每个模块列举的常见问题，
                <br/>
                点击链接：<a href="/questions">ysc.jd.com/questions</a> 可以快速跳转至常见问题列表，如果常见问题中未有您遇到的问题，您可以通过我们提供的解答问题渠道咨询客户解决您的问题。
              </p>
              <p>诸葛.智享</p>
              <p>2017年11月16日</p>
            `,
          },
          {
            path: 'notice6',
            title: '对我们产品还满意吗？欢迎您的反馈！',
            desc: `
              <p>尊敬的诸葛.智享用户：</p>
              <p>您好！</p>
              <p>为了诸葛.智享产品更好的满足您的需求，我们制作了一份产品使用调研问卷，您可以点击以下链接：
              <a href="http://cn.mikecrm.com/SuI3XM8" target="_blank">http://cn.mikecrm.com/SuI3XM8</a>，
                将您对产品的建议和反馈提交给我们，以便我们更好的改善产品，更全面的为您服务。
              </p>
              <p>诸葛.智享</p>
              <p>2017年11月16日</p>
            `,
          },
          {
            path: 'notice7',
            title: '商家开通子账号权限说明！',
            desc: `
              <p>尊敬的诸葛.智享用户：</p>
              <p>您好！</p>
              <p>
                产品在初期推广阶段，会选择性的对一些商家开通产品使用权限，如果商家需要给其公司的员
                工也进行产品使用权限的开通，
                请发邮件给我们的客服邮箱：zgzx-chanpin@jd.com，
                邮件中需要包含员工在京东商城登录的账号名，以及说明需要给该员工开通哪些产品的使用权限。
              </p>
              <p>诸葛.智享</p>
              <p>2017年11月16日</p>
            `,
          },
        ],
        currentContent: null
      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.currentContent = this.contents.find((item) => item.path == this.$route.params.id)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
body {
  font-size: 14px;
  color: #000;
  font-family: 'Microsoft YaHei';
}
.c_homeNotice {
  width: 1000px;
  margin: 40px auto;
  color: #000;
}
.c_Title{
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 400;
}

</style>
<style lang="scss">
.c_homeNotice {
  .c_Content{
    p{
      font-family: 'Microsoft YaHei';
      font-weight: 400;
      font-size: 14px;
      letter-spacing: normal;
      line-height: 24px;
      margin-top: 24px;
      margin-bottom: 0;
    }
  }
}
</style>
